{
  "users": {
    "label": "Utilisateurs"
  },
  "userGroups": {
    "label": "Groupes"
  },
  "userProfiles": {
    "label": "Profils"
  }
}
